import {getField, updateField} from 'vuex-map-fields'
import BaseStore from './baseStore'
import {generateSingleItemOverview} from "@/store/baseOverview";

export const namespaced = true;

let baseUrl = '/topo_profiles/';

const baseStore = new BaseStore(baseUrl);
const baseOverview = generateSingleItemOverview({
    itemFilter: (item, stabSchematisationStage) => item.stab_schematisation_stage === stabSchematisationStage.id,
});


export const state = {
    ...baseStore.state,
    ...baseOverview.state,
    dialog: false,
    writeLoading: false,
};

export const mutations = {
    ...baseStore.mutations,
    ...baseOverview.mutations,
    updateField,
}
export const actions = {
    ...baseStore.actions,
    ...baseOverview.actions,
}

export const getters = {
    ...baseOverview.getters,
    getField,
}

